(() => {
  if (window.ysPurchaseReady) return;
  window.ysPurchaseReady = true;
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'es-ES', {style:'currency',currency:'EUR'}).format(cents / 100);
  function productRoot(el) { return el.closest('.yp-info,.ypr-info'); }
  document.addEventListener('change', event => {
    if (!event.target.matches('[data-ys-quantity]')) return;
    const root = productRoot(event.target);
    const quantity = Number(event.target.value);
    const input = root?.querySelector('form input[name="quantity"]');
    if (input) input.value = quantity;
    const button = root?.querySelector('[data-add],form[action*="/cart/add"] button[type="submit"]');
    if (button) button.textContent = 'Añadir al carrito · ' + money(quantity === 2 ? 3999 : 2999);
    const stickyPrice = document.querySelector('[data-ys-sticky-price]');
    if (stickyPrice) stickyPrice.textContent = money(quantity === 2 ? 3999 : 2999);
  });
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-ys-review-link],.yp-rate,.ypr-rate');
    if (!link) return;
    const reviews = document.querySelector('.yr');
    if (!reviews) return;
    event.preventDefault();
    const picker = reviews.querySelector('[data-product-filter]');
    if (picker) { picker.value='gid://shopify/Product/11183503343959';picker.dispatchEvent(new Event('change',{bubbles:true})); }
    reviews.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});
  });
  let observer;
  function initSticky() {
    observer?.disconnect();
    const sticky = document.querySelector('[data-ys-sticky]');
    const main = document.querySelector('.yp-info [data-add], .ypr-info form[action*="/cart/add"] button[type="submit"]');
    if (!sticky || !main) return;
    const button = sticky.querySelector('[data-ys-sticky-add]');
    button.onclick = () => { if (!main.disabled) main.click(); };
    function update(visible) {
      sticky.hidden = visible;
      document.body.classList.toggle('ys-has-sticky', !visible);
      button.disabled = main.disabled;
    }
    observer = new IntersectionObserver(entries => update(entries[0].isIntersecting),{threshold:0.2});
    observer.observe(main);
    new MutationObserver(() => {button.disabled=main.disabled;}).observe(main,{attributes:true,attributeFilter:['disabled']});
  }
  initSticky();
  document.addEventListener('shopify:section:load',initSticky);
})();

/* YOONSEUL · Contrarreembolso en la ficha de producto.
   Añade un segundo botón debajo de «Añadir al carrito». Mete en el carrito
   exactamente lo mismo que el botón principal (pack elegido + complemento si
   está marcado), deja el pedido marcado como contrarreembolso y lleva directo
   al pago, donde la clienta elige «Contrarreembolso» como método.
   El pedido es un pedido normal de Shopify, así que Meta registra la compra en
   la página de gracias igual que con cualquier otro pago. */
(() => {
  if (window.ysCodReady) return;
  window.ysCodReady = true;

  const ETIQUETA = 'Pagar al recibir · Contrarreembolso';
  const NOTA = 'Pagas al repartidor cuando te llegue el pedido.';
  const ATRIBUTO = 'Método de pago';
  const VALOR = 'Contrarreembolso';

  const raiz = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function montar(form) {
    const principal = form.querySelector('[data-ysc-submit]');
    if (!principal || form.querySelector('[data-ys-cod]')) return;

    const boton = document.createElement('button');
    boton.type = 'button';
    boton.setAttribute('data-ys-cod', '');
    boton.className = principal.className.replace('ysc__btn--accent', '').trim();
    boton.style.cssText = 'margin-top:10px;background:transparent;color:var(--ysc-ink);border:2px solid var(--ysc-ink);';
    const texto = document.createElement('span');
    texto.textContent = ETIQUETA;
    boton.appendChild(texto);

    const nota = document.createElement('p');
    nota.textContent = NOTA;
    nota.style.cssText = 'margin:8px 0 0;font-size:13px;text-align:center;color:var(--ysc-muted);';

    principal.insertAdjacentElement('afterend', boton);
    boton.insertAdjacentElement('afterend', nota);

    const sincronizar = () => {
      boton.disabled = principal.disabled;
      boton.style.opacity = principal.disabled ? '.45' : '1';
    };
    sincronizar();
    new MutationObserver(sincronizar).observe(principal, { attributes: true, attributeFilter: ['disabled'] });

    boton.addEventListener('click', async () => {
      const elegido = form.querySelector('input[name="id"]:checked') || form.querySelector('input[name="id"]');
      const id = elegido && elegido.value;
      if (!id) return;

      const articulos = [{ id: Number(id), quantity: 1 }];
      const complemento = form.querySelector('[data-ysc-addon]');
      if (complemento && complemento.checked && !complemento.disabled) {
        articulos.push({ id: Number(complemento.value), quantity: 1 });
      }

      const original = texto.textContent;
      texto.textContent = 'Preparando tu pedido…';
      boton.disabled = true;

      const cabeceras = { 'Content-Type': 'application/json', Accept: 'application/json' };
      try {
        const respuesta = await fetch(raiz() + 'cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: cabeceras,
          body: JSON.stringify({ items: articulos })
        });
        if (!respuesta.ok) throw new Error('cart');

        await fetch(raiz() + 'cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: cabeceras,
          body: JSON.stringify({ attributes: { [ATRIBUTO]: VALOR } })
        });

        window.location.href = raiz() + 'checkout';
      } catch (e) {
        texto.textContent = 'No se pudo continuar';
        boton.disabled = false;
        setTimeout(() => { texto.textContent = original; }, 3000);
      }
    });
  }

  function iniciar() {
    document.querySelectorAll('#ysc-form, form[action*="/cart/add"]').forEach((form) => {
      if (form.querySelector('[data-ysc-submit]')) montar(form);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
  document.addEventListener('shopify:section:load', iniciar);
})();
